// extracted by mini-css-extract-plugin
export default {"wrapper":"Header_wrapper__SYMDU","container":"Header_container__gvXEf"};